import React, { useRef, useState, useEffect } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import './aboutUs.css';
import homeIcon from '../../assets/icons/home.svg';
import TextField from '@mui/material/TextField';
import skyeairLogo from '../../assets/images/skyeair1.svg';
import img1 from '../../assets/images/aboutBgImg.png';
import News from '../../components/shared/news/news';
import Partner from '../shared/partners/partner';
import Questions from '../shared/questions/questions';
import Footer from '../shared/footer/footer';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import Header from '../shared/header/header';
import useGetdata from '../../Hooks/useGetData';
import useGetAboutData from '../../Hooks/useGetAboutData';
import { useSelector } from 'react-redux';
import useIsMobile from '../../Hooks/useIsMobile';
import SnackbarNav from '../main/SnackbarNav/SnackbarNav';
import MobileMenu from '../main/SnackbarNav/MobileMenu';
const AboutUs = () => {
  const isMobile = useIsMobile();
  const [menuOpen, setMenuOpen] = useState(false);
  useGetdata();
  useGetAboutData();
  const data = useSelector((store) => store.data.AboutData)
  const sectionRef = useRef(null);
 
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ['start start', 'end start'],
  });
  const visionItems = [
  ];
  const [cardData,setCardData] = useState({});
  const [Title,setTitle] = useState("");
  const [Vision,setVision] = useState({});
  const [Purpose,setPurpose] = useState({});
  const [Awards,setAwards] = useState({});
  useEffect(() => {
    if (data?.items) {
      data.items.forEach((ele) => {
        if (ele.Section === "Logistics") {
          setCardData(ele.Content);
          setTitle(ele.Title);
        } else if (ele.Section === "Moto") {
           setVision(ele.Content)
        }
        else if (ele.Section === "Purpose") {
          setPurpose(ele.Content)
       }
       else if (ele.Section === "Awards") {
        setAwards(ele.Content)
     }
      }); 
    }
  }, [data]);
  

  const droneY = useTransform(scrollYProgress, [0, 0.5], ['0vh', '-100vh']);
  const droneOpacity = useTransform(scrollYProgress, [0, 0.4], [1, 0]);

  const leftTextX = useTransform(scrollYProgress, [0.2, 0.6], [0, -300]);
  const rightTextX = useTransform(scrollYProgress, [0.2, 0.6], [0, 300]);
  const textOpacity = useTransform(scrollYProgress, [0, 0.4], [1, 0]);
  const [showModal, setShowModal] = useState(false);

  const handleOpen = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const formJson = Object.fromEntries(formData.entries());
    // console.log(formJson);
    handleClose();
  };

  // const cards = [
  //   { title: "Continuous Tech Development", desc: "We continuously expand our multirole capabilities, integrating new offerings into our technology infrastructure to enhance community service.", icon: img1 },
  //   { title: "Continuous Tech Development", desc: "We continuously expand our multirole capabilities, integrating new offerings into our technology infrastructure to enhance community service.", icon: img1 },
  //   { title: "Continuous Tech Development", desc: "We continuously expand our multirole capabilities, integrating new offerings into our technology infrastructure to enhance community service.", icon: img1 },
  // ];

  const dynamicItems = [
    { year: 2020, description: "Expanding to serve over 1 billion people across India with fast, efficient, and seamless drone delivery." },
    { year: 2021, description: "Expanding to serve over 1 billion people across India with fast, efficient, and seamless drone delivery." },
    { year: 2022, description: "Expanding to serve over 1 billion people across India with fast, efficient, and seamless drone delivery." },
    { year: 2023, description: "Expanding to serve over 1 billion people across India with fast, efficient, and seamless drone delivery." },
    { year: 2024, description: "Expanding to serve over 1 billion people across India with fast, efficient, and seamless drone delivery." }
  ];

  const NextArrow = (props) => {
    const { onClick } = props;
    return (
      <div
      className="mobile-next-arrow"
        style={{
          display: 'block',
          background: 'rgb(121 121 121)',
          color: '#fff',
          padding: '10px',
          position: 'absolute',
          right: 12,
          zIndex: 2,
          top: '50%',
          cursor: 'pointer',
          transform: 'translateY(-50%)'
        }}
        onClick={onClick}
      >›</div>
    );
  };

  const PrevArrow = (props) => {
    const { onClick } = props;
    return (
      <div
        className="mobile-left-arrow"
        style={{
          display: 'block',
          background: 'rgb(121 121 121)',
          color: '#fff',
          padding: '10px',
          position: 'absolute',
          zIndex: 2,
          top: '50%',
          cursor: 'pointer',
          transform: 'translateY(-50%)'
        }}
        onClick={onClick}
      >‹</div>
    );
  };

  const [itemsToShow, setItemsToShow] = useState(window.innerWidth < 480 ? 2 : 3);
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalItems = data?.items?.length;
  const slidesToShow = 3.5;
  const lastVisibleItem = Math.min(Math.ceil(currentSlide + itemsToShow), totalItems);


  const sliderRef = useRef(null);
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    beforeChange: (oldIndex, newIndex) => {
      setCurrentSlide(newIndex);
    },
    afterChange: (index) => {
      if (index + slidesToShow >= totalItems) {
        setTimeout(() => {
          sliderRef.current?.slickGoTo(0);
        }, 500); 
      }
    },
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };


  useEffect(() => {
    const handleResize = () => {
      setItemsToShow(window.innerWidth < 480 ? 1 : 3);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  return (
    <div className="about-us-page-wrapper">
      {/* Section 1: Home */}
      <div >
        <div ref={sectionRef} className="about-us-container">
          <div className="vg">
            
          </div>

          <div className="home-container">
            {/* <div className="home-header">
              <Link to="/home" className="p-left"><img src={skyeairLogo} alt="Not Found" /></Link>
              <div className="about-us p-right" onClick={handleOpen}>
                <img src={homeIcon} alt="Icon" height={22} />
                <span >Delivery with us Today</span>
              </div>
            </div> */}

            <Header />

            <img className="main-bg-img" src={img1} alt="Icon" width={'100%'} />

            <div className="aboutus-home-content">
              <div className="heading-container-about">
                <motion.h3
                  className="heading-about capitalize-first-letter"
                  initial={{ x: -300, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ duration: 1 }}
                  style={{ x: leftTextX, opacity: textOpacity }}
                >
                  Elevating Last Mile Logistics
                </motion.h3>

                <motion.h3
                  className="heading-f1 capitalize-first-letter"
                  initial={{ x: 300, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ duration: 1 }}
                  style={{ x: rightTextX, opacity: textOpacity }}
                >
                   with Precision and Speed
                </motion.h3>
              </div>
            </div>
            <section>
      {!isMobile && <SnackbarNav />}
      {isMobile && !menuOpen && (
        <button className="menu-toggle" onClick={() => setMenuOpen(true)}>
          ☰
        </button>
      )}
       {isMobile && menuOpen && (
        <MobileMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />
      )}
      </section>
          </div>
        </div>
        <div className="drone-section-container">
        </div>
      </div>

      {/* 2nd Screen */}

      <div className="about-content-wrapper">
        <motion.h4
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="heading1 capitalize-first-letter"
        >
         {Title}
        </motion.h4>

        <div className="cards-container1">
          {cardData?.Items?.map((card, index) => (
            <div
              key={index}
              className="card"
              initial={{ opacity: 0, y: 250 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1, duration: 1 }}
            >
              <img src={card.ImageUrl} height={250} width={'100%'} alt="Not Found" />
              <div className="about-strategies">
                <h5 class="mt-1 card-title">{card.Title}</h5>
                <p class="mt-1 font-light">{card.Description}</p>
              </div>

            </div>
          ))}
        </div>
      </div>

      {/* 3rd Screen */}

      <div className="vision-container row">
        {Vision?.Items?.map((item, index) => (
          <div className="col-md-5" key={index}>
            <div className="vision-card">
              <img src={item.LogoUrl} alt="Icon" width={100} height={100} />
              <h2 className="fw-bold text-center mb-2 mt-4">{item.Title}</h2>
              <p className="text-left">{item.Description}</p>
            </div>
          </div>
        ))}
      </div>

       {/* 4rd Screen */}

       <div className="purpose-container row">
          <div className="col-md-4" >
            <div className="purpose-card">
              <h2 className="mb-2 mt-5 heading-our-purpose capitalize-first-letter">Our purpose</h2>
              <p className=" mt-4">{Purpose?.Description}</p>
            </div>
          </div>
          <div className="col-md-5 purpose-img" >
          <img src={Purpose?.ImageURL} alt="Icon" width={'100%'} height={400} />
          </div>
        
      </div>

      {/* 5rd Screen */}

      <div className="awards-container">
        <h1 className="fw-bold text-center my-5"> Our Awards</h1>
        <div style={{ width: '100%', maxWidth: '1145px', margin: '0 auto' }}>
          <Slider ref={sliderRef} {...settings} className="custom-slider-class">
            {Awards?.Items?.map((item, index) => (
              <div key={index} style={{ padding: '10px', marginRight: '15px'}}
              >
                <div style={{
                  border: '1px solid #ddd',
                  borderRadius: '10px',
                  minHeight: '150px',
                  marginRight: '15px'
                }}>
                  <img src={item?.ImageUrl} alt="Icon" width={'100%'} />
                  <div className="carousel-heading-data">
                    <h6 className="text-left fw-bold" style={{ margin: '0 0 10px' }}>{item.Title}</h6>
                    <p className="text-left" style={{ color: '#555', cursor: 'pointer'  }}
                     onClick={() => window.open( item?.Link, '_blank')} >{item.Description}</p>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
          <div className="carousel-count" style={{ textAlign: 'right', marginTop: '33px', marginBottom: '5px', marginRight: '66px', fontWeight: 'bold' }}>
            {String(lastVisibleItem).padStart(2, '0')}/{String(totalItems).padStart(2, '0')}
          </div>
        </div>
      </div>

      <Partner source={'about'} />
      <News source={'about'}/>
      <Questions source={'about'}  />
      <Footer />

    </div>
  );
};

export default AboutUs;
